/* eslint-disable max-classes-per-file */
class Distribution {
  constructor({
    adults, children, infants, adl, chd, enf,
  }, context) {
    this.adults = adults || adl;
    this.children = children || chd;
    this.infants = infants || enf;
    this.context = context;
  }

  getDistribution(context) {
    const { adults, children, infants } = this;
    const adultsTxt = `${adults} ${context.t(['adult', 'adults', 'n'], { n: adults })}`;
    const childrenTxt = children ? `, ${children} ${context.t(['child', 'children', 'n'], { n: children })}` : '';
    const infantsTxt = infants ? `,${infants} ${context.t(['infant', 'infants', 'n'], { n: infants })}` : '';
    return adultsTxt + childrenTxt + infantsTxt;
  }

  get paxes() {
    return this.getDistribution(this.context);
  }
}

class BookingDistribution {
  constructor(bookingDistribution) {
    this.rooms = this.getRoomsDistribution(bookingDistribution);
    this.distribution = this.getInitialDistribution();
  }

  getInitialDistribution() {
    return this.rooms.reduce((acc, curr) => (
      {
        adults: acc.adults + curr.adults,
        children: acc.children + curr.children,
        infants: acc.infants + curr.infants,
      }
    ));
  }

  getRoomsDistribution(roomsDistribution) {
    const isList = Array.isArray(roomsDistribution);
    if (isList) {
      return roomsDistribution.map((room) => new Distribution(room));
    }
    return [new Distribution(roomsDistribution)];
  }
}

export { Distribution, BookingDistribution };
